import { toast } from 'react-toastify';

const defaultOption = {
  position: 'top-center',
  autoClose: 5000,
  hideProgressBar: false,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  closeOnClick: true,
  draggable: false,
  progress: undefined,
  theme: 'light',
};

export const warnToast = (messeage, option = null) => {
  return toast.warn(messeage, {
    ...defaultOption,
    option,
  });
};

export const successToast = (message, option = null) => {
  return toast.success(message, {
    ...defaultOption,
    option,
  });
};

export const errorToast = (message, option = null) => {
  return toast.error(message, {
    ...defaultOption,
    option,
  });
};

export const updateToast = (toastId, message, typeValue, position) => {
  return toast.update(toastId, {
    position: position,
    render: message,
    type: typeValue,
    isLoading: false,
    autoClose: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    limit: 1,
  });
};

export const loadingToast = (message) => {
  return toast.loading(message, {
    limit: 1,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    autoClose: 5000,
    closeOnClick: true,
  });
};
